import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import { useLabels } from '../../hooks/useLabels';
import BillsEditor from './BillsEditor';

function EditBill() {
	const { t } = useLabels();
	const { id } = useParams();
	const navigate = useNavigate();
	const { state } = useLocation();
	const returnTo = state?.returnTo || `/AdminScreen/bills/bill/${id}`;
	// 'instance' when the caller is editing one generated period of a recurring
	// gasto — the editor then writes only that Bill, never its template.
	const scope = state?.scope === 'instance' ? 'instance' : 'full';

	return (
		<EntityList>
			<Helmet>
				<title>{`Editar ${t('entity.bill')}`}</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: t('entity.asset.plural'), to: '/AdminScreen/assets' },
					{ label: `Editar ${t('entity.bill')}` },
				]}
				title={`Editar ${t('entity.bill')}`}
				subtitle='Actualizá los datos del gasto.'
			/>
			<BillsEditor
				mode='edit'
				scope={scope}
				billId={id}
				onCancel={() => navigate(returnTo)}
				onSaved={() => navigate(returnTo)}
				saveLabel='Guardar'
			/>
		</EntityList>
	);
}

export default EditBill;
